export { DocumentsModule } from './documents.module'
export { documentsRoute } from './constants';
export { DocumentsComponent } from './documents.component';